import { useCallback, useState } from 'react';

import Coords from 'state/Coords';
import { Status } from 'hooks/requests/fetchUtils';
import useFetchApi from 'hooks/useFetchApi';
import useQueryParameters from 'hooks/useQueryParameters';

const PATH = '/api/store_attribution';

export interface AddressObject {
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface StoreAttributionResult {
  storeNumber: string;
  // FIXME: ADS has not implemented this yet. Make it a required field once
  // it's full implemented.
  distance?: number;
}

type StoreAttributionHook = () => [
  (
    address: AddressObject,
    position?: Coords,
  ) => Promise<StoreAttributionResult>,
  Status,
  boolean,
];

export class StoreAttributionError extends Error {}

const useStoreAttributionRequest: StoreAttributionHook = () => {
  const [error, setError] = useState<boolean>(false);
  const [status, fetch] = useFetchApi();
  const { mockStoreAttribution } = useQueryParameters();

  const attributeStoreRequest = useCallback(
    async (
      address: AddressObject,
      position?: Coords,
    ): Promise<StoreAttributionResult> => {
      setError(false);

      const response = await fetch(PATH, {
        method: 'POST',
        body: {
          address1: address.address1,
          address2: address.address2,
          city: address.city,
          state: address.state,
          zip: address.zip,
          latitude: position && position.latitude,
          longitude: position && position.longitude,
          mockResponse: mockStoreAttribution,
        },
      });

      if (!response.ok) {
        setError(true);
        return Promise.reject(new StoreAttributionError());
      }

      const storeAttributionResults: StoreAttributionResult = await response.json();
      return storeAttributionResults;
    },
    [fetch, mockStoreAttribution],
  );

  return [attributeStoreRequest, status, error];
};

export default useStoreAttributionRequest;
